import React from "react";
import swaggerContent from "./colortokensAPI.json";
import { Link } from "react-router-dom";
import { RedocStandalone } from "redoc";

const bannerStyle: React.CSSProperties = {
  background: "#033B73",
  color: "white",
  fontSize: "16px",
  fontWeight: "bold",
  padding: "10px 0",
  display: "flex",
  alignItems: "center",
};

const logoStyle: React.CSSProperties = {
  marginLeft: "10px"
};

const textContainerStyle: React.CSSProperties = {
  flex: "1",
  textAlign: "center"
};

const linkStyle = {
  color: "#1E90FF",
  textDecoration: "underline",
};

function App() {
  return (
    <>
      <div style={bannerStyle}>
        <img src="xshield.png" alt="Redocly Logo" style={logoStyle} />
        <div style={textContainerStyle}>
          Explore interactive Postman collections{" "}
          <Link style={linkStyle} target="_blank" to="https://www.postman.com/ctdevs/workspace/kaizen-rest-apis-internal/overview">
            here
          </Link>
        </div>
      </div>
      <RedocStandalone
        spec={swaggerContent}
        options={{
          showExtensions: true,
          nativeScrollbars: true,
          theme: {
            colors: {
              primary: { main: "#033B73" },
            },
          },
        }}
      />
    </>
  );
}

export default App;
